import React from "react";
import {useEffect} from 'react';
import {useSelector,useDispatch} from 'react-redux';
import { Button, TextField, Card, CardContent, Grid} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import {useHistory} from 'react-router-dom';
import { useLocation } from "react-router-dom";
import * as userActions from '../actions/authenticationActions';
import * as briefActions from '../actions/briefActions';
import _ from 'lodash';
import AsyncSelect from 'react-select/async';
import CancelIcon from '@material-ui/icons/Cancel';
import {isValidPermalink} from '../utility';

const UiInput = makeStyles({
  root : {
    "& .MuiInputBase-input": {
        border: 'none',
        width: '100%'
    },
    "& .MuiInputBase-input:focus": {
        outline:'none',
        boxShadow: 'none'
    },
  }
});

function DashboardAdthriveNewBriefInput(props){
  const isUpdateType = props.type === 'update'; // can be 'new' or 'update' type depending on whether brief is optimizing new or existing post
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [keyword, setKeyword] = React.useState('');

  const currentPage = useSelector(state => state.currentPage);
  const [activePost, setActivePost] = React.useState(null);

  
  const uiInputClass = UiInput();

  const handleCreateBrief = () => {
    if(_.isEmpty(keyword)){
      alert('Please choose a valid keyword');
      return;
    }
    let url = '';
    if(isUpdateType){
      url = activePost.value.permalink;
    }
    dispatch(briefActions.createAdthriveBrief({keyword, url})).then(() => {
      if(isUpdateType){
        window.AP.tanalytics.track('Brief Created', {type: 'updated', brief: url});
      } else{
        window.AP.tanalytics.track('Brief Created', {type: 'new'});
      }

      setKeyword('');
      if(_.isFunction(props.onCreate)){
        props.onCreate();
      }
    }).catch((errors) => {
      console.log('errors when creating content brief', errors);
      if(errors && errors[0] && errors[0].detail){
        alert('Something went wrong creating the brief. Message: '+errors[0].detail);
      }
    });
    
  }

  const loadUrls = (inputValue, callback) => {
    jQuery.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        action: 'search_posts',
        s: inputValue
      }
    }).then(function(response) {
      let choices = _.map(response.posts, (post) => {
        return {
          label: post.post_title,
          value: post
        };
      })
      callback(choices);

      // if the current activePost is empty, replace it with the post that matches the currentPage's permalink
      // this should run once at the very beginning when the async select initially populates
      if(activePost === null){
        let currentPost = _.find(response.posts, {ID: `${currentPage.postId}`});

        // only set the current post if it is a valid permalink
        if(isValidPermalink(currentPost.permalink)){
          setActivePost({
            label: currentPost.post_title,
            value: currentPost
          });
        }
      }
    });
  }

  const handleUrlChange = (post) => {
    setActivePost(post);
  }


  return(
      <Card style={{marginBottom:10,borderRadius:'0.3rem',cursor:'pointer', overflow: 'visible', position: 'relative'}} >
          <CardContent style={{paddingBottom: '13px', padding: '13px'}}>
            <Grid container xs="12" direction="row">
                <Grid item xs="9">
                  <TextField
                    placeholder="keyword"
                    type="text"
                    value={keyword}
                    onChange={(event) => {setKeyword(event.target.value)}}
                    className={uiInputClass.root}
                    />
                </Grid>
                <Grid item xs="3">
                    <Button variant="contained" color="primary" size="small" onClick={handleCreateBrief}>Create</Button>
                </Grid>
                {isUpdateType && <Grid item xs="12">
                  <div style={{marginTop: '5px'}}>For post: </div>
                  <AsyncSelect
                    loadOptions={loadUrls}
                    defaultOptions
                    onChange={handleUrlChange}
                    classNamePrefix="react-select"
                    value={activePost}
                  />
                </Grid>}
            </Grid>
            <CancelIcon style={{position: 'absolute', top: '-10px', right: '-11px', color: '#50575e'}} onClick={props.handleClose} />
          </CardContent>
      </Card>
  );

}

export default DashboardAdthriveNewBriefInput;